import { makeStyles } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import waves from "../../assets/optimized/Landing/App Section/waves.svg";

export default function FooterNew() {
  const classes = useStyles();
  return (
    <section className=" relative">
      <div className={classes.wave}>
        <div className="container-bt z-0">
          <div className="flex  justify-between md:flex-nowrap flex-wrap gap-y-10 mb-20">
            <div>
              <h2 className="mb-5 font-semibold">Company</h2>
              <div className="flex gap-x-20 md:flex-nowrap flex-wrap">
                <div className="font-light opacity-50 flex flex-col gap-y-3 ">
                  <Link to="/aboutus">
                    <p>About Us</p>
                  </Link>
                  <a
                    href="https://pocketbits.in/blog/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Blog</p>
                  </a>
                  <Link to="/feespage">
                    <p>Fee Structure</p>
                  </Link>
                  <Link to="/tandc">
                    <p>Terms & Conditions</p>
                  </Link>

                  <Link to="/aml">
                    <p>AML & KYC</p>
                  </Link>
                </div>{" "}
                <div className="font-light opacity-50 flex flex-col gap-y-3">
                  <Link to="/careers">
                    <p>We’re hiring</p>
                  </Link>
                  {/* <Link to="/bugbounty">
                    {" "}
                    <p>Bug Bounty Program</p>
                  </Link> */}
                  <a
                    href="https://feed.pocketbits.in/en"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Site Updates</p>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <h2 className="mb-5 font-semibold">Support</h2>
              <div className="flex gap-x-20">
                <div className="font-light opacity-50 flex flex-col gap-y-3">
                  <a
                    href="https://support.pocketbits.in/support/home"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Support Center</p>
                  </a>{" "}
                  <a
                    href="https://support.pocketbits.in/support/tickets/new"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Support Ticket</p>
                  </a>
                  <a
                    href="mailto:alliance@pocketbits.in"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Partnership Queries</p>
                  </a>
                  <a
                    href="mailto:alliance@pocketbits.in"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Coin Listing Request</p>
                  </a>
                  {/* <p>Media Assets</p> */}
                  <Link to="/contactus">
                    <p>Contact us</p>
                  </Link>
                  {/* <p>Frequently Asked Questions</p> */}
                </div>{" "}
              </div>
            </div>
            <div>
              <h2 className="mb-5 font-semibold">Follow Us!</h2>
              <div className="flex gap-x-20">
                <div className="font-light opacity-50 flex flex-col gap-y-3">
                  <a
                    href="https://twitter.com/PocketBitsIndia"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Twitter</p>
                  </a>
                  <a
                    href="https://www.instagram.com/pocketbits.in/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Instagram</p>
                  </a>
                  <a
                    href="https://www.facebook.com/Pocketbits.in"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Facebook</p>
                  </a>{" "}
                  <a
                    href="https://t.me/pocketbits"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Telegram</p>
                  </a>{" "}
                  <a
                    href="https://www.youtube.com/channel/UC1JBJkM7V-jmylPYtSnPmqw"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>Youtube</p>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/pocketbits.in/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                  >
                    <p>LinkedIn</p>
                  </a>
                </div>{" "}
              </div>
            </div>
            <div>
              <h2 className="mb-5 font-semibold">App</h2>
              <div className="">
                <div className="font-light  flex flex-col">
                  <img
                    src={
                      require("../../assets/img/google-play-badge.png").default
                    }
                    className="max-w-[120px] cursor-pointer"
                    alt="play-store"
                    onClick={() => {
                      window.open(
                        "https://play.google.com/store/apps/details?id=com.pocketbits",
                        "_blank"
                      );
                    }}
                  ></img>
                  <img
                    src={
                      require("../../assets/optimized/Landing/Footer/iosAppStore.svg")
                        .default
                    }
                    className="max-w-[106px] ml-2 "
                    alt="app-store"
                  ></img>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ opacity: "0.4" }}
            className="text-gray-400 font-light leading-relaxed text-center"
          >
            <p className="font-xs mb-3">
              Trading in cryptocurrencies are subject to market, technical and
              legal risks.<br className="md:block hidden"></br> The prices
              fluctuate based on global demand and supply.
            </p>
            <p>© 2023 Pocketbits Co. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </section>
  );
}

const useStyles = makeStyles((theme) => ({
  wave: {
    padding: "40px 0px",
    // transform: " scaleY(-1)",
    // marginBottom: "-450px",
    // marginTop: "-200px",
    // height: "550px",
    backgroundImage: `url('${waves}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    backgroundPosition: "center -300px",
    [theme.breakpoints.down("sm")]: {
      // backgroundPosition: "-1200px -500px",
      marginBottom: "-450px",
      // display: "none",
    },
  },
}));
